import { combineReducers } from "redux";
import { conversationReducer } from "./Conversation";
import { notificationReducer } from "./Notification";
import { signInReducer } from "./Signin";
import { signUpReducer } from "./Signup";
import { RootState } from "./types";
import { userConversationReducer } from "./UserConversation";

export const rootReducer = combineReducers<RootState>({
  signUp: signUpReducer,
  signIn: signInReducer,
  conversation: conversationReducer,
  notification: notificationReducer,
  userConversation: userConversationReducer,
});
